import { Button, Typography } from 'design-component';
import { palette } from 'styles/color';
import styled from 'styled-components';
import { useCallback } from 'react';
import { IconHwp, IconPpt, IconPdf, IconDocx, IconExcel } from 'assets/icon';
import { useTranslation } from 'react-i18next';
import { ButtonPropsType } from 'design-component/Button';

export interface FileButtonProps extends Pick<ButtonPropsType, 'onClick'> {
  type: 'hwp' | 'slide' | 'pdf' | 'word' | 'sheet';
  style?: React.CSSProperties;
}

export default function FileButton(props: FileButtonProps) {
  const { t } = useTranslation();
  const { type, onClick, style } = props;

  const getIcon = useCallback((type: string) => {
    switch (type) {
      case 'hwp':
        return <IconHwp></IconHwp>;
      case 'slide':
        return <IconPpt></IconPpt>;
      case 'pdf':
        return <IconPdf></IconPdf>;
      case 'word':
        return <IconDocx></IconDocx>;
      case 'sheet':
        return <IconExcel></IconExcel>;
      default:
        return undefined;
    }
  }, []);

  return (
    <FileButtonBase
      variant="contained"
      color="primary"
      startIcon={getIcon(type)}
      onClick={onClick}
      style={style}>
      {t(type)}
      {/* <Typography size="14px" weight={500} color={palette.gray[800]}>
       
      </Typography> */}
    </FileButtonBase>
  );
}

const FileButtonBase = styled(Button)`
  width: 94px;
  height: 38px;

  // border: none;
  box-shadow: 0.71px 0.71px 2.83px 0px #0000001a;
  box-shadow: 0px 0.71px 2.12px 0px #00000014;
  gap: 2px;
`;
